import { IUploaderColumnConfig } from "../../../../../../components/ui/UploaderFlow/types/types";
import { StakeholderColDefFieldNamesEnum } from "../../../enums/AgGridColDefFieldNameEnum";

export const ROLE_GRID_UPLOADER_CONFIG: IUploaderColumnConfig[] = [
  {
    key: "name",
    name: "Name",
    type: "text",
    placeholder: 'Role Name Placeholder',
    required: true
  },
  {
    key: StakeholderColDefFieldNamesEnum.BusinessArea,
    name: "Business Area",
    type: "entityRelation", // This marks it as an entity relation field
    placeholder: 'Business Area Placeholder',
    required: true
  },
];